import AccountTypeSelect from "@/components/form/account-type-select";
import {
  makePickerField,
  type PickerFieldProps,
} from "@/fields/_internal/make-picker-field";
import type { AccountType } from "@/types/openapi-enum";

/** **Value is an `AccountType`** — what kind of account this is, not a vendor trade. */
export type AccountTypeFieldProps = PickerFieldProps<AccountType | null>;

export const AccountTypeField = makePickerField<AccountType | null>({
  name: "AccountTypeField",
  control: AccountTypeSelect,
  popout: true,
});
